import Collapsible from 'react-collapsible'
import { ReactComponent as ArrowDown } from '../../assets/images/arrow-down.svg';
import './protean-collapsible.scss';
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';



const Header = ({ onToggle, show, title, AdditionalHeaderContent }) => {
    return (
        <div role='button' tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onToggle(); }}
            aria-expanded={show} className="collapsible-title d-flex align-items-center justify-content-between" onClick={onToggle}>
            <div className='d-flex align-items-center justify-content-between w-100'>
                <span>{title}</span>
                {AdditionalHeaderContent?.()}
                <ArrowDown className={`collapse-arrow ${show ? 'rotate-180' : ''}`} />
            </div>
        </div>
    )
}

Header.propTypes = {
    show: PropTypes.bool.isRequired,
    AdditionalHeaderContent: PropTypes.elementType,
    onToggle: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};


/**
 * ProteanCollapsible component
 *
 * A reusable collapsible wrapper component that shows/hides content
 * with a clickable header.
 *
 * @param {Object} props
 * @param {string} props.id - Unique identifier for the collapsible
 * @param {React.ReactNode} props.children - Content to render inside the collapsible
 * @param {string} props.className - Optional additional class for styling
 * @param {boolean} props.open - Controls open state of the collapsible
 * @param {function} props.onToggle - Callback function when the collapsible is toggled
 * @param {string|React.ReactNode} props.title - Title displayed in the header
 * @param {React.ElementType} props.AdditionalHeader - Optional additional content to display in the header
 */

const ProteanCollapsible = ({ id, children, className, open, onToggle, title, AdditionalHeader }) => {
    const [isOpen, setIsOpen] = useState(open);

    useEffect(() => {
        setIsOpen(open);
    }, [open]);

    const toggleHandler = () => {
        setIsOpen(prev => !prev);
        onToggle(isOpen);
    }

    return (
        <div id={id ?? title} className={`collapsible-container ${className || ''}`}>
            <Collapsible
                open={isOpen}
                trigger={<Header show={isOpen} onToggle={toggleHandler} title={title} AdditionalHeaderContent={AdditionalHeader} />}
            >
                <div className='collapsible-content-container'>
                    {children}
                </div>
            </Collapsible>
        </div>
    )
}

ProteanCollapsible.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onToggle: PropTypes.func,
    AdditionalHeader: PropTypes.elementType,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};



export default ProteanCollapsible